import kbl1 from '../Kartawijaya Bussiness Loft/Kartawijaya Business Loft (4).webp'
import kbl2 from '../Kartawijaya Bussiness Loft/Kartawijaya Business Loft (1).webp'
import kbl3 from '../Kartawijaya Bussiness Loft/Kartawijaya Business Loft (2).webp'
import kbl4 from '../Kartawijaya Bussiness Loft/Kartawijaya Business Loft (3).webp'
import kbl5 from '../Kartawijaya Bussiness Loft/Kartawijaya Business Loft (5).webp'



const kblimages =[
kbl1,kbl2,kbl3,kbl4,kbl5
]

export default kblimages;